import { FC } from 'react'

import { DrawIcon } from 'assets/icons/draw-icon'

import { GreenButton, RedButton } from 'shared/components'
import { Dialog, DialogClose, DialogContent, DialogTitle, DialogTrigger } from 'shared/components/ui/dialog'
import { Tooltip, TooltipContent, TooltipTrigger } from 'shared/components/ui/tooltip'

import { useGameEventContext } from '../event-context'
import { useGameContext } from '../game-context'
import { isGameOpen } from '../utils'

export const RequestDrawDialog: FC = () => {
  const { requestDraw } = useGameEventContext()
  const { game } = useGameContext()

  const drawIcon = <DrawIcon className="h-5 lg:h-10" />

  return (
    <Dialog>
      {!isGameOpen(game.status) ? (
        <GreenButton disabled iconLeading={drawIcon} />
      ) : (
        <Tooltip>
          <TooltipTrigger asChild>
            <DialogTrigger asChild>
              <GreenButton iconLeading={drawIcon} />
            </DialogTrigger>
          </TooltipTrigger>
          <TooltipContent>Request a Draw</TooltipContent>
        </Tooltip>
      )}
      <DialogContent className="w-11/12 max-w-[850px] rounded-xl p-5">
        <DialogTitle>Request a draw?</DialogTitle>
        <DialogClose>
          <div className="flex gap-10">
            <RedButton className="w-full" text="Cancel" />
            <GreenButton className="w-full" text="Confirm" onClick={requestDraw} />
          </div>
        </DialogClose>
      </DialogContent>
    </Dialog>
  )
}
